import React, { useState } from "react";
import { Typography, Row, Col } from "antd";
import { CheckOutlined, PlusOutlined } from "@ant-design/icons";
import { features, SERVICE_ADDONS } from "../../data/data";
import { WEBSITE_BASE_URL } from "../../../../env";
import "./ServiceAddOns.scss";

const { Title, Paragraph } = Typography;

const ServiceAddOns = () => {

    return (
        <Row className="container-fluid service-content-container j-sb-a-start">
            <Col lg={8} sm={24} xs={24} style={{ paddingRight: 64}}>
                <h1 className="manrope f-30 w-700 black-00 lh-40">
                    Service & add-ons
                </h1>
                <p className="manrope f-16 w-500 black-00 lh-24">
                    We offer a variety of additional pay-as-you-go services to fit your individual needs.
                </p>
            </Col>
            <Col lg={16} sm={24} xs={24}>
                <div className="services__list">
                    {/* Desktop Table */}
                    <table className="desktop-table">
                        <tbody>
                            {SERVICE_ADDONS.map((serv, index) => (
                                <tr key={index}>
                                    <td className="feature-check-row">
                                        <div
                                            className={`service-check add-icon`}>
                                            <PlusOutlined />
                                        </div>
                                    </td>
                                    <td className="title manrope f-14 w-700 black-085 mb-4">{serv.title}</td>
                                    <td className="description">
                                        <ul className="mb-0" style={{ padding: "16px 24px"}}>
                                            {serv.services.map((service) => (
                                                <li className="manrope f-14 w-500 lh-22 black-085 justify-space-between">
                                                    <p className="mb-4">{service.service}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </td>
                                    <td className="description">
                                        <ul className="mb-0" style={{ padding: "16px 24px"}}>
                                            {serv.services.map((service) => (
                                                <li className="manrope f-14 w-500 lh-22 black-085 justify-space-between">
                                                    <p className="mb-4">{service.fee}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {/* Mobile Table */}
                    <table className="mobile-table">
                        <tbody>
                            {SERVICE_ADDONS.map((serv, index) => (
                                <tr key={index} className="mobile-feature">
                                    <div className="mobile-feature-row">
                                        <div
                                            className={`feature-check add-icon`}>
                                            <PlusOutlined />
                                        </div>
                                        <div className="title manrope f-14 w-700 black-085 mb-4">{serv.title}</div>
                                    </div>
                                    <td className="mob-description">
                                        <ul className="mb-0">
                                            {serv.services.map((service) => (
                                                <li className="manrope f-14 w-500 lh-22 black-085 j-sb-a-start">
                                                    <p className="mb-4 service">{service.service}</p>
                                                    <p className="mb-4 text-left">{service.fee}</p>
                                                </li>
                                            ))}
                                        </ul>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="manrope f-12 w-400 black-085 mt-16">Add-ons are available by contacting our <a href={`${WEBSITE_BASE_URL}/contact-us`}>Sales Team</a></div>
                </div>
            </Col>

        </Row>
    );
};

export default ServiceAddOns;
